import { FC } from "react";
import { IListPartProps } from "./IListPartProps";
import { PartPage } from "../components";

export const ListPart: FC<IListPartProps> = ({ pageLink, className }) => {
    return <>
        {(pageLink?.pageId) && <>
            <PartPage
                pageId={pageLink.pageId}
                pageLink={pageLink}
                className={className} />
        </>}
    </>
}
